import { render, staticRenderFns } from "./dangerRegularCheckInfo.vue?vue&type=template&id=04da7d64"
import script from "./dangerRegularCheckInfo.vue?vue&type=script&lang=js"
export * from "./dangerRegularCheckInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04da7d64')) {
      api.createRecord('04da7d64', component.options)
    } else {
      api.reload('04da7d64', component.options)
    }
    module.hot.accept("./dangerRegularCheckInfo.vue?vue&type=template&id=04da7d64", function () {
      api.rerender('04da7d64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/chm/danger/dangerRegularCheckInfo.vue"
export default component.exports